<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="400px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="hrissecondary"
        block
        class="white--text"
        v-on="on"
      >
        Create Transaction Date Rule
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Claim Transaction Date Validity Rule"
      text="Create Claim Transaction Date Validity Rule"
      class="mb-0"
    > 
      <v-container v-if="dialog">
        <v-row no-gutters>
          <v-col
            cols="12"
            class="py-0"
          >
            <v-text-field
              v-model="startDay"
              v-validate="'required|min_value:0'"
              :min="0"
              :error-messages="errors.collect('startDay')"
              type="number"
              data-vv-name="startDay"
              data-vv-as="start day"
              label="Start Day"
              class="my-0"
              @keydown.native="['e', 'E', '+', '-', '.'].includes($event.key) && $event.preventDefault()"
            />
          </v-col>
          <v-col
            cols="12"
            class="py-0"
          >
            <v-text-field
              v-model="endDay"
              v-validate="'required|min_value:0'"
              :min="0"
              :error-messages="errors.collect('endDay')"
              type="number"
              data-vv-name="endDay"
              data-vv-as="end day"
              label="End Day"
              class="my-0"
              @keydown.native="['e', 'E', '+', '-', '.'].includes($event.key) && $event.preventDefault()"
            />
          </v-col>

          <v-col
            cols="12"
            class="pt-2"
          >
            <span> Requires remark? </span>
            <v-radio-group
              v-model="requiresRemark"
              class="mt-0"
              row
            >
              <v-radio
                label="No"
                :value="0"
              />
              <v-radio
                label="Yes"
                :value="1"
              />
            </v-radio-group>
          </v-col>
          
          <v-col
            cols="12"
            class="pt-2"
          >
            <span> Requires additional approver? </span>
            <v-radio-group
              v-model="requiresAdditionalApprover"
              class="mt-0"
              row
            >
              <v-radio
                label="No"
                :value="0"
              />
              <v-radio
                label="Yes"
                :value="1"
              />
            </v-radio-group>
          </v-col>
        </v-row>
        
        <v-card-actions>
          <v-spacer />
          <v-btn
            :disabled="progressing"
            text
            class="px-10"
            @click="dialog = false"
          >
            Close
          </v-btn>
          <v-btn
            :loading="progressing"
            color="hrissecondary"   
            class="white--text px-10"       
            @click="submitForm"
          >
            Create
          </v-btn>
        </v-card-actions>
      </v-container>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    data () {
      return {
        dialog: false,        
        progressing: false,
        startDay: null,
        endDay: null,
        requiresRemark: 0,
        requiresAdditionalApprover: 0,
      }
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.progressing = true
    
            this.$api.claimTransactionDateValidityRules().create(this.prepareFormData())
              .then((res) => {
                if (res.status === 200 || res.status === 201) {
                  this.$emit('created')              
                  this.$snack({ message: 'Added new rule' })
                  this.$resetData()
                  this.dialog = false                 
                }
              })
              .catch(() => {
                this.$snack({
                  color: 'error',
                  message: 'Failed to create new rule',
                })
              })
              .then(() => {
                this.progressing = false
              })
          })
      },
      prepareFormData () {
        return {
          start_day: this.startDay,
          end_day: this.endDay,
          requires_remark: this.requiresRemark,
          requires_additional_approver: this.requiresAdditionalApprover,
        }
      },
    },
  }
</script>
